export default __webpack_public_path__ + "static/media/7d.fe535be6.png";